<div class="p-fluid grid formgrid">
  <div class="field col-12 md:col-3">
    <label for="r003_code">Código</label>
    <input id="r003_code" type="text" pInputText [(ngModel)]="filters.code"/>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r003_kind">Tipo da peça</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r003_kind" [options]="comboOptions.kind" [(ngModel)]="filters.kind" placeholder="Todos"
                optionLabel="label" optionValue="value" [filter]="true" filterBy="label" [showClear]="true"
                *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
  <div class="field col-12 md:col-3">
    <label for="r003_advertising">Ação de comunicação</label>
    <p-skeleton height="2.5rem" styleClass="mb-2" *ngIf="isLoadingComboOptions"></p-skeleton>
    <p-dropdown id="r003_advertising" [options]="comboOptions.advertising" [(ngModel)]="filters.advertising"
                placeholder="Todos" optionLabel="label" optionValue="value" [filter]="true" filterBy="label"
                [showClear]="true" *ngIf="!isLoadingComboOptions"></p-dropdown>
  </div>
</div>
